"use strict";

exports.__esModule = true;
exports.getSharesightCountry = void 0;
var _locales = require("./locales");
var getSharesightCountry = exports.getSharesightCountry = function getSharesightCountry() {
  var cookies = typeof document !== 'undefined' ? document.cookie.split(';') : undefined;
  var countryCookieString = cookies === null || cookies === void 0 ? void 0 : cookies.find(function (cookie) {
    return cookie.includes('sharesight_country');
  });
  if (!countryCookieString) return null;
  var countryId = countryCookieString.split('=')[1];
  return _locales.locales.find(function (locale) {
    return locale.id === countryId;
  });
};